import createGetFormNames from './selectors/getFormNames';
import plain from './structure/plain';
export default createGetFormNames(plain);


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/getFormNames.js
// module id = 1204
// module chunks = 22